import { render, staticRenderFns } from "./onGetRowClassName-editor.vue?vue&type=template&id=6fb10898&scoped=true&"
import script from "./onGetRowClassName-editor.vue?vue&type=script&lang=js&"
export * from "./onGetRowClassName-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb10898",
  null
  
)

export default component.exports